const colors={
darkGreen:"rgba(47, 72, 88, 1)",
lightGreen:"rgba(3, 149, 144, 1)",
dark:"rgba(51,51,51,1)"
}
export default colors